import { render, staticRenderFns } from "./PlayerOfferPersonalSuperWhale.vue?vue&type=template&id=5afac10f&scoped=true&"
import script from "./PlayerOfferPersonalSuperWhale.vue?vue&type=script&lang=js&"
export * from "./PlayerOfferPersonalSuperWhale.vue?vue&type=script&lang=js&"
import style0 from "./PlayerOfferPersonalSuperWhale.vue?vue&type=style&index=0&id=5afac10f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afac10f",
  null
  
)

export default component.exports